import http from '@/plugins/axios/axios';

export default class DashboardService {

    buscar(idEmpresa, idCnpj, grupos) {       
        return http.get(`/api/dashboard?idEmpresa=${idEmpresa}&idCnpj=${idCnpj}&g=${grupos}`);
    } 
}